import React from 'react';

export default function AdminUserPage() {
  return <div>Administração do Usuário (restrito)</div>;
}
